"use client";

import React from "react";
import { SpacingType } from "@/types";
import { sectionVariants } from "@/types";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import parse from "html-react-parser";
import { SectionWrapper } from "../components/SectionWraper";
import { variantBackgroundColors } from "@/lib/utils";

interface Accordion1Props { 
  darkMode?: boolean; 
  variant?: sectionVariants;
  spacing?: SpacingType;
  usedInPageNav?: boolean;
  pageNavTitle?: string;
  themeChangeOnScroll?: boolean;
  title?: string;
  accordionItem?: {
    title?: string;
    content?: string;
  }[];
  attributes?: React.HTMLProps<HTMLElement>;
}

const Accordion1 = ({
  darkMode = false,
  variant = "A",
  spacing,
  usedInPageNav = false,
  pageNavTitle = "Faq 1",
  themeChangeOnScroll = false,
  title,
  accordionItem,
  attributes,
}: Accordion1Props) => {

  const accordionBg = variantBackgroundColors(darkMode, variant);
  
  return (
    <SectionWrapper
      usedInPageNav={usedInPageNav}
      pageNavTitle={pageNavTitle}
      themeChangeOnScroll={themeChangeOnScroll}
      spacing={spacing}
      variant={variant}
      darkMode={darkMode}
      heroSection={false}
      componentName="faq1"
      attributes={attributes}
    >
      <div className="container">
        <div className="flex flex-col md:flex-row gap-6 mb-6 lg:mb-10 md:justify-between md:items-center" data-aos="fade-up">
          {title && (
            <h2>
              {parse(title)}
            </h2>
          )}
        </div>
        <div data-aos="fade-up" data-aos-delay="100">
          {accordionItem && accordionItem.length > 0 && 
            accordionItem.map((item, itemIndex) => (
              <Accordion type="multiple" key={itemIndex}>
                <AccordionItem
                  key={itemIndex}
                  value={`item-${itemIndex}`}
                  className={`rounded-md border-b-0 ${accordionBg} px-5 py-2 mb-4`}
                >
                  <AccordionTrigger className="text-left !no-underline cursor-pointer flex items-center gap-6">
                    {item.title}
                  </AccordionTrigger>
                  <AccordionContent className="pt-6 [&>p]:mb-4">{parse(item.content || "")}</AccordionContent>
                </AccordionItem>
              </Accordion>
            ))}
        </div>
      </div>
    </SectionWrapper>
  );
};

export { Accordion1 };